
import { CircularProgress } from "@mui/material"

const Loader = () => {
    return (
        <div className="content">
        <CircularProgress />
        </div>
    )
}

export default Loader;